module.exports = __webpack_public_path__ + "img/45444.8b86b47d.png";